import { useStore } from '../store';
import { searchIndex } from '../search';

export function SpecList() {
  const specs = useStore((state) => state.specs);
  const removeSpec = useStore((state) => state.removeSpec);
  const endpoints = useStore((state) => state.endpoints);

  const handleRemove = (id: string) => {
    removeSpec(id);
    // Rebuild search index without removed spec's endpoints
    const remainingEndpoints = endpoints.filter((e) => e.specId !== id);
    searchIndex.buildIndex(remainingEndpoints);
  };

  if (specs.length === 0) return null;

  return (
    <div className="spec-list">
      <h3>Loaded APIs</h3>
      {specs.map((spec) => (
        <div key={spec.id} className="spec-item">
          <div className="spec-info">
            <span className="spec-title">{spec.title}</span>
            <span className="spec-version">v{spec.version}</span>
            <span className="spec-count">{spec.endpoints.length} endpoints</span>
          </div>
          <button
            className="spec-remove"
            onClick={() => handleRemove(spec.id)}
            title="Remove API"
          >
            ×
          </button>
        </div>
      ))}
    </div>
  );
}
